module.exports = __webpack_public_path__ + "static/media/slack.0397c8d3.png";